import React from 'react';
import ContactTemplate from '@templates/Contact';

export default function Services() {
  return <ContactTemplate />;
}
